import { AddressData, PaymentData, PaymentResponse } from '../types/payment'

const WEBHOOK_CREATE_PAYMENT =
  'https://conector.assistenteinfinity.com.br/webhook/ee7c69cf-5677-4b67-93aa-658cc77c69bf-post'
const WEBHOOK_CHECK_STATUS =
  'https://conector.assistenteinfinity.com.br/webhook/c5299cc9-e720-4cdb-8a04-b73d4ccebbd0'

const CONNECTOR_N8N_API_TOKEN = import.meta.env.VITE_CONNECTOR_N8N_API_TOKEN

if (!CONNECTOR_N8N_API_TOKEN) {
  throw new Error('Variável de ambiente CONNECTOR_N8N_API_TOKEN não definida')
}

export const createPayment = async (
  paymentData: PaymentData
): Promise<PaymentResponse> => {
  const response = await fetch(WEBHOOK_CREATE_PAYMENT, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${CONNECTOR_N8N_API_TOKEN}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(paymentData),
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(
      `Erro HTTP: ${response.status}. Detalhes: ${
        errorData.message || response.statusText
      }`
    )
  }

  const data = await response.json()

  const paymentResponse = Array.isArray(data) ? data[0] : data

  // Mapear os campos da API para o formato esperado
  if (paymentResponse.encodedImage) {
    paymentResponse.qrCode = `data:image/png;base64,${paymentResponse.encodedImage}`
  }

  if (paymentResponse.payload) {
    paymentResponse.pixCode = paymentResponse.payload
  }

  return paymentResponse
}

export const checkPaymentStatus = async (
  paymentId: string,
  companyId?: string
): Promise<PaymentResponse> => {
  // se não vier companyId, usa um default "3"
  const finalCompanyId = companyId || "3";

  const response = await fetch(
    `${WEBHOOK_CHECK_STATUS}?id=${paymentId}&companyId=${finalCompanyId}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${CONNECTOR_N8N_API_TOKEN}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Erro ao verificar status: ${response.status}`);
  }

  return await response.json();
};

export const fetchAddressByCEP = async (
  cep: string
): Promise<AddressData | null> => {
  try {
    const response = await fetch(
      `https://viacep.com.br/ws/${cep.replace(/\D/g, '')}/json/`
    )
    const data = await response.json()

    if (!data.erro) {
      return {
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        localidade: data.localidade || '',
        uf: data.uf || '',
      }
    }
  } catch (error) {
    console.error('Erro ao buscar CEP:', error)
  }

  return null
}

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (error) {
    console.error('Erro ao copiar texto:', error)
    return false
  }
}
